import { render } from "./CardInfo.vue?vue&type=template&id=1fae2c15&scoped=true"
import script from "./CardInfo.vue?vue&type=script&lang=js"
export * from "./CardInfo.vue?vue&type=script&lang=js"

import "./CardInfo.vue?vue&type=style&index=0&id=1fae2c15&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1fae2c15"

export default script